export const ARTICLE_WEIGHT_MODAL = "ArticleWeightModal";
export const MISSING_SKU_MODAL = "MissingSkuModal";
export const BOX_ERROR_MODAL = "BoxErrorModal";
export const FAILURE_TO_DELIVER_MODAL = "FailureToDeliverModal";
export const FINALIZE_SORT_MODAL = "FinalizeSortModal";
export const IPACK_BOX_TOO_SMALL_MODAL = "IPackBoxTooSmallModal";
export const MISSING_SKU_WARNING_MODAL = "MissingSkuWarningModal";
export const OPERATOR_CONFIRM_MODAL = "OperatorConfirmModal";
export const OPERATOR_INPUT_MODAL = "OperatorInputModal";
export const PARTIAL_DELIVERY_CONFIRMATION_MODAL = "PartialDeliveryConfirmationModal";
export const SCAN_SHIPPING_LABEL_MODAL = "ScanShippingLabelModal";
export const WARNING_MODAL = "WarningModal";
export const WRONG_WORKSTATION_MODAL = "WrongWorkstationModal";
export const FINALIZE_EMPTY_AFRAMEMIXED_MODAL = "FinalizeEmptyAFrameMixedModal";
